module.exports = __webpack_public_path__ + "static/media/service1.0ebf8850.svg";